import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextInputComponent,
      multi: true
    }
  ]
})
export class TextInputComponent implements OnInit, ControlValueAccessor {

  @Input()
  labelText: string;

  @Input()
  type: string;

  @Input()
  disabled: boolean;

  @Input()
  placeholder: string;

  @Input()
  max: number;

  @Input()
  min: number;

  @Input()
  required: boolean;

  @Input()
  submitted: boolean;

  @Input()
  requiredMessage = '';

  @Input()
  complementaryFieldText:string

  restCharacters?: number;
  warningLabel: string;
  textModel: string;

  onChange!: (value: any) =>  void;

  constructor( private rf: ChangeDetectorRef) { 
    this.labelText = '';
    this.placeholder = '';
    this.required = false;
    this.submitted = false;
    this.disabled = false;
    this.type = 'text';
    this.textModel = '';
    this.warningLabel = '';
    this.max = 0;
    this.min = 0;
    this.complementaryFieldText = ''
  }

  writeValue(obj: any): void {
    this.textModel = obj;
    this.rf.detectChanges();
    this.textChange();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit(): void {

    if (this.max ) {
      this.restCharacters = this.max;
    }
  }

  textChange() {
    if (this.max) {
      this.restCharacters = this.max - this.textModel?.length;
    }
  }

  validate(): boolean {

    if(this.min > 0 && this.textModel.length < this.min && this.textModel.length > 0 && this.submitted){
      this.warningLabel = `${this.labelText} Invalido.`;
      return false;
    }

    if (this.max && this.textModel.length > this.max) {
      this.warningLabel = `Se ha pasado de los ${this.max} carácteres máximos`;
      return false;
    }

    if (this.type == 'number' && (Number(this.textModel) < 0 || (this.required && this.submitted && Number(this.textModel) <= 0))) {
      this.warningLabel = this.requiredMessage || `Ingrese su ${this.labelText}.`;
      return false;
    }

    if (!this.submitted) {
      return true;
    }

    if (this.required && !this.textModel) {
      this.warningLabel = this.requiredMessage || `Ingrese su ${this.labelText}.`;
      return false;
    }

    if (this.type == 'email') {
      const expression: RegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      this.warningLabel = 'Ingrese una dirección válida.';
      return expression.test(this.textModel);
    }

    if(!this.textModel && ((this.type == 'telephone-number-optional' && this.complementaryFieldText != '') || (this.type == 'telephone-feature' && this.complementaryFieldText !=''))){
      this.warningLabel = 'Complete el campo';
      return false
    }
    if(this.type == 'telephone-feature' && (this.required || this.textModel.length > 0)){
      const expression: RegExp = /^0\d{2,4}$/;
      this.warningLabel = 'Ingrese una caracteristica valida.';
      return expression.test(this.textModel);
    }
    if(this.type == 'telephone-number' && (this.required || this.textModel.length > 0)){
      const expression: RegExp = /^15\d{6,8}$/;
      this.warningLabel = 'Ingrese un numero celular valido.';
      return expression.test(this.textModel);
    }
    if(this.type == 'telephone-number-optional' && this.textModel.length > 0){
      const expression: RegExp = /^\d{6,8}$/;
      this.warningLabel = 'Ingrese un numero valido.';
      return expression.test(this.textModel);
    }

    if (this.textModel?.length > 0) {
      const emojiRegex: RegExp =
        /(?:\uD83D[\uDC00-\uDFFF]|\uD83C[\uDF00-\uDFFF]|\uD83E[\uDD00-\uDDFF]|\uD83C[\uDDE6-\uDDFF]{1,2}|\u2600-\u26FF|\u2700-\u27BF|[\u200D\uFE0F])/g;
    
      this.warningLabel = 'No ingrese iconos.';
      const normalizedText = this.textModel.normalize('NFC');
      const hasEmojis = emojiRegex.test(normalizedText);
        
      return !hasEmojis;
    }

    return true;
  }

}
